import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import styles from './portalUserEdit.module.scss';
import PulpoField from '../../../../pulpo_visualizer/fields';
import Checkbox from '../../../checkbox';
import Button from '../../../button/button';
import { clearProfile, editUser, fetchUserProfile } from '../redux/actions';
import Loading from '../../../loading';
import { getPortalUsers } from '../../../../modules/PermitManagement/redux/action';

class ProfileEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      info: {},
      showFormErrors: false,
      emailError: false,
      existingEmail: false,
      secondaryEmailError: false,
      existingNumber: false,
      fieldErrors: {
        first_name: true,
        last_name: true,
        phone: true
      },
      loadingStatus: false
    };
  }

  componentDidMount() {
    const { profile, actionFetchUserProfile, actionFetchProtalUsers } = this.props;
    if (!profile) {
      actionFetchUserProfile();
    }
    actionFetchProtalUsers(profile?.tenant?.[0]?.id);
  }

  static getDerivedStateFromProps(props, state) {
    if (Object.keys(state.info)?.length === 0 && props.profile) {
      let info = {
        id: props.profile?.id,
        first_name: props.profile?.first_name,
        last_name: props.profile?.last_name,
        email: props.profile?.user?.email,
        secondary_email: props.profile?.secondary_email,
        phone: props.profile?.phone,
        notification_secondary: props.profile?.notification_secondary
      };
      let fieldErrors = {
        first_name: false,
        last_name: false,
        phone: (!((props.profile?.portal_airport?.airport_settings?.new_portal_user_username_is || 'phone') === 'phone'
          || props.profile?.phone)),
        email: (!((props.profile?.portal_airport?.airport_settings?.new_portal_user_username_is || 'phone') === 'email'
          || props.profile?.user?.email?.length !== 0)),
        job_function: false
      };
      return { ...state, info, fieldErrors };
    }
    return state;
  }

  componentDidUpdate(prevProps) {
    const { updateAPIAction } = this.props;
    if (!prevProps.updateAPIAction?.success && updateAPIAction?.success) {
      this.manageLoading();
    }
  }

  componentWillUnmount() {
    const { actionClearProfile } = this.props;
    actionClearProfile();
  }

  manageLoading = () => {
    const { history } = this.props;
    this.setState({ loadingStatus: false }, () => {
      history.push('/profile');
    });
  }

  handleCancel = () => {
    const { history } = this.props;
    history.push('/profile');
  };

  handleFieldChange = (answer, fieldId) => {
    if (fieldId === 'email') {
      this.setState({ emailError: false });
    }
    if (fieldId === 'secondary_email') {
      this.setState({ secondaryEmailError: false });
    }
    if (fieldId === 'secondary_email' && answer === '') {
      this.setState(prevState => ({
        info: {
          ...prevState.info,
          [fieldId]: null,
          notification_secondary: false
        }
      }));
    } else {
      this.setState(prevState => ({
        info: {
          ...prevState.info,
          [fieldId]: answer
        }
      }));
    }
  };

  handleFieldErrorChanged = (id, value) => {
    this.setState(prevState => ({
      fieldErrors: {
        ...prevState.fieldErrors,
        [id]: value
      }
    }));
  };

  handleValidation = (value, id) => {
    let isEmailValid = false;
    if (value?.length > 0) {
      const mail = new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(
        value
      );
      if (id === 'secondary_email') {
        this.setState({ secondaryEmailError: !mail });
      } else {
        this.setState({ emailError: !mail });
      }
      isEmailValid = mail;
    } else if (value === '' || value === undefined) {
      isEmailValid = true;
    }
    return isEmailValid;
  };

  handleEdit = () => {
    const { fieldErrors, info } = this.state;
    const {
      actionEditUserProfile,
      portalUsers, profile
    } = this.props;
    const noErrors = Object.keys(fieldErrors).every(
      k => fieldErrors[k] === false
    );
    let number = info.phone;
    let givenEmail = info.email ? info.email.toLowerCase() : '';
    if (number !== undefined && number !== '') {
      number = number[0] + number.slice(1).replace(/[^\d]/g, '');
    }
    const data = info;
    data.phone = number || '';
    const isValid = this.handleValidation(data.email, 'email');
    const isSecondaryEmailReq = data.secondary_email?.length > 0 ? this.handleValidation(data.secondary_email, 'secondary_email') : true;
    const existing_number = number?.length > 0 ? portalUsers?.filter(user => user.phone === number) : [];
    const existing_email = givenEmail.length > 0 ? portalUsers?.filter(user => user.email === data.email) : [];
    let isExisting = true;
    if (profile.portal_airport.airport_settings.new_portal_user_username_is === 'email') {
      isExisting = ((existing_email.length === 0)
        || (info.id && (existing_email.length === 1)
          && existing_email.length < 2));
    } else {
      isExisting = ((existing_number.length === 0)
        || (info.id && (existing_number.length === 1)
          && existing_number.length < 2));
    }
    if (
      noErrors
      && isValid && isSecondaryEmailReq
      && isExisting
    ) {
      this.setState({ loadingStatus: true });
      data.email = givenEmail;
      if (
        (data.email === '' && data.email.length === 0)
        || data.email === undefined
      ) {
        delete data.email;
      }
      if (info.id) {
        data.fullname = `${data.first_name} ${data.last_name}`;
        actionEditUserProfile(data);
      } else {
        this.setState({ showFormErrors: true, loadingStatus: false });
      }
    } else {
      if (existing_number.length > 0) this.setState({ existingNumber: true });
      if (existing_email.length > 0) this.setState({ existingEmail: true });
      this.setState({ showFormErrors: true });
    }
  };

  render() {
    const { profile } = this.props;
    const { info, showFormErrors, emailError, existingEmail, secondaryEmailError, existingNumber,
      loadingStatus
    } = this.state;
    const temp = profile?.portal_airport?.airport_settings?.new_portal_user_username_is || 'phone';
    return (
      <>
        {loadingStatus && <Loading loadingStatus={loadingStatus} />}
        <div className={styles.newItem}>
          <div className={styles.content}>
            <div className={styles.details}>
              <FormattedMessage
                id="portal.user.edit_form_title"
                defaultMessage="Edit Portal User"
              />
            </div>
            <div>
              <PulpoField
                key="first_name"
                id="first_name"
                type="string"
                translationID="portal.user.first_name"
                title="First Name"
                isRequired
                handleValueChange={(a, b) => this.handleFieldChange(a, b)}
                answer={info.first_name}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={(a, b) => this.handleFieldErrorChanged(a, b)
                }
              />
              <PulpoField
                key="last_name"
                id="last_name"
                type="string"
                translationID="portal.user.last_name"
                title="Last Name"
                isRequired
                handleValueChange={(a, b) => this.handleFieldChange(a, b)}
                answer={info.last_name}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={(a, b) => this.handleFieldErrorChanged(a, b)
                }
              />
              <PulpoField
                key="email"
                id="email"
                type="string"
                translationID="portal.user.email"
                title="Email Address"
                handleValueChange={(a, b) => this.handleFieldChange(a, b)}
                answer={info.email}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={(a, b) => this.handleFieldErrorChanged(a, b)
                }
                isRequired={temp === 'email'}
                disabled={temp === 'email'}
              />
              <div className={styles.error}>
                {emailError && (
                  <h6 className={styles.para}>
                    <FormattedMessage
                      id="settings.users.email_valid"
                      defaultMessage="Email is not valid"
                    />
                  </h6>
                )}
              </div>
              <div className={styles.error}>
                {!info?.id && existingEmail && (
                  <h6 className={styles.para}>
                    <FormattedMessage
                      id="settings.users.exitsing_email"
                      defaultMessage="Email is already in use"
                    />
                  </h6>
                )}
              </div>
              <PulpoField
                key="email"
                id="secondary_email"
                type="string"
                translationID="portal.user.secondary.email"
                title="Secondary Email"
                handleValueChange={(a, b) => this.handleFieldChange(a, b)}
                answer={info.secondary_email}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={(a, b) => this.handleFieldErrorChanged(a, b)
                }
              />
              <div className={styles.error}>
                {secondaryEmailError && (
                  <h6 className={styles.para}>
                    <FormattedMessage
                      id="settings.users.email_valid"
                      defaultMessage="Email is not valid"
                    />
                  </h6>
                )}
              </div>
              <Checkbox
                id="notification_secondary"
                label="Use Secondary Email For Notification?"
                checked={info.notification_secondary}
                onChange={a => this.handleFieldChange(a.target.checked, 'notification_secondary')}
                isApprovals
              />
              <PulpoField
                key="phone"
                id="phone"
                type="telephone"
                translationID="profile.phone"
                title="Phone Number"
                isRequired={temp === 'phone'}
                handleValueChange={(a, b) => this.handleFieldChange(a, b)}
                answer={info.phone}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={(a, b) => this.handleFieldErrorChanged(a, b)
                }
                disabled={temp === 'phone'}
              />
              <div className={styles.error}>
                {!info?.id && existingNumber && (
                  <h6 className={styles.para}>
                    <FormattedMessage
                      id="settings.users.exitsing_number"
                      defaultMessage="Phone number already in use"
                    />
                  </h6>
                )}
              </div>
            </div>
          </div>
          <div className={styles.footer}>
            <Button
              onClick={this.handleCancel}
              translationID="roles.footer.cancel"
              defaultText="Cancel"
              action="tertiary"
            />
            <div className={styles.save}>
              <Button
                onClick={this.handleEdit}
                translationID="roles.footer.save"
                defaultText="Save"
                action="primary"
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

ProfileEdit.propTypes = {
  profile: PropTypes.shape({}).isRequired,
  actionFetchUserProfile: PropTypes.func.isRequired,
  actionEditUserProfile: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  profile: state.auth.profile,
  portalUsers: state.permitManagement.portalUsers,
  updateAPIAction: state.profile.apiStatusUser
});

const mapDispatchToProps = dispatch => ({
  // Fetch portal_airport
  actionFetchUserProfile: () => {
    dispatch(fetchUserProfile());
  },
  actionEditUserProfile: (data) => {
    dispatch(editUser(data));
  },
  actionFetchProtalUsers: (data) => {
    dispatch(getPortalUsers(data));
  },
  actionClearProfile: () => {
    dispatch(clearProfile());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ProfileEdit));
